import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import React, {
  useRef,
  useMemo,
  useState,
  useEffect,
  useCallback,
} from "react";

import BatchProductEdit from "./BatchProductEdit";
import BatchBulkUpdateModal from "./BatchBulkUpdateModal";
import AddBatchInventoryFooter from "./AddBatchInventoryFooter";
import {
  AddIcon,
  DeleteIcon,
  ResetCartIcon,
} from "../../../../assets/icons/iconsProvider";
import SearchInventory from "../SearchInventory/SearchInventory";
import AddCustomItem from "../../Invoices/AddInvoice/AddCustomItem";
import { custom, success } from "../../../../redux/actions/actionsUtilities";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { systemActions, inventoryActions } from "../../../../redux/actions";
import {
  Button,
  EditableReactDataTableComponent,
} from "../../../../shared/components";
import {
  TABLE_IDS,
  EMPTY_STRING,
  toastMessages,
  globalConstants,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  transactionConstants,
  BATCH_INVENTORY_DEFAULT_PRODUCT_OBJECT,
} from "../../../../constants";
import {
  handleResetPrices,
  handleEmptyOnFocus,
  getInStockProducts,
  addToCartInBatchTrade,
  handleBatchBulkDelete,
  onChangeProductQuantity,
  handleBulkUpdateCondition,
  handleTotalCogsValueChange,
  handleAddBatchInventoryPark,
  getAddBatchInventoryColumns,
  setDefaultProductDataObject,
  handleSubmitAddBatchInventory,
  handleCalculateEachProductPercentage,
  isScreenLessThan1440,
  getBatchTotalCalculation,
  isAddInventoryInProgress,
  handleEditCardClick,
} from "../../../../shared/utility";
import { useScreenWidth } from "../../../../shared/hooks/windowResize";

const AddBatchInventory = (props) => {
  //-------Destructure props
  const {
    customTypes,
    currentStore,
    productTags,
    spinnerArray,
    markupPresets,
    tradeinMargin,
    shopifySettings,
    activateSpinner,
    handleDraftModal,
    customCategories,
    handleClearFilter,
    deactivateSpinner,
    addBatchInventory,
    setAddBatchInventory,
    isBatchInventoryModal,
    addBatchInventoryDraft,
    addBatchInventorySubmit,
    setIsBatchInventoryModal,
    priceChartingProductInfo,
    setPriceChartingProductInfo,
    emptyPriceChartingProductObject,
    activateImportInventorySpinner,
    addBatchInventoryRetrievedDraft,
    setAddBatchInventoryRetrievedDraft,
  } = props;
  const [screenWidth] = useScreenWidth();
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [isCustomItemModal, setIsCustomItemModal] = useState(false);
  const [editCustomProduct, setEditCustomProduct] = useState({});
  //-------Toggle confirmation modal
  const toggleConfirmationModal = () => {
    setIsConfirmationModal(!isConfirmationModal);
  };

  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };

  //-------handle conformation actions
  const handleConfirmYesButtonClick = () => {
    handleClearBatch();
    toggleConfirmationModal();
  };

  //-------handle edit button click
  const handleEditCardRowClick = (productDetail) => {
    handleEditCardClick({
      productDetail,
      setEditCustomProduct,
      toggleCustomItemModal,
      setEditTradeObject,
      setPriceChartingProductInfo,
      toggleAddInventoryItemModal,
    });
  };

  //-------column headers for batch inventory table
  const columnHeaders = useMemo(
    () =>
      getAddBatchInventoryColumns({
        productTags,
        currentStore,
        markupPresets,
        tradeinMargin,
        addBatchInventory,
        handleEmptyOnFocus,
        handleEditCardRowClick,
        setAddBatchInventory,
        onChangeProductQuantity,
      }),
    // eslint-disable-next-line
    [addBatchInventory]
  );

  //-------useref
  const asyncSelectRef = useRef();

  //-------useStates
  const [editTradeObject, setEditTradeObject] = useState({});
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [rowsToUpdateCondition, setRowsToUpdateCondition] = useState([]);
  const [isBulkModal, setIsBulkModal] = useState(false);
  const [bulkUpdateCondition, setBulkUpdateCondition] = useState("");
  const [addInventoryItemModal, setAddInventoryItemModal] = useState(false);
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  const [gridState, setGridState] = useState({
    pageSize: 500,
    pageIndex: 0,
    sortBy: [],
  });
  const [productDataObject, setProductDataObject] = useState(
    BATCH_INVENTORY_DEFAULT_PRODUCT_OBJECT
  );
  const totalBatchCalculation = useMemo(
    () => getBatchTotalCalculation(addBatchInventory, false),
    [addBatchInventory]
  );

  //------- Show inStock Quantity and Price according
  //------- to condition

  //-------Toggle Add Inventoty Item Modal
  const toggleAddInventoryItemModal = () =>
    setAddInventoryItemModal(!addInventoryItemModal);

  const scrollToTop = () => {
    var tableElement = document.getElementsByClassName("rdt_TableBody")[0];
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleCloseModal = (isModalSubmit = false) => {
    // if close is triggered after submitting inventory, then don't close the modal
    if (isAddInventoryInProgress(spinnerArray)) {
      return;
    }

    setIsBatchInventoryModal(false);
    if (!isModalSubmit && addBatchInventory.length) {
      handleDraftModal(transactionConstants.ADD_BATCH_INVENTORY_DRAFT_MODAL);
    } else {
      setAddBatchInventory([]);
      setAddBatchInventoryRetrievedDraft({}); // remove inventoryDraftId on modal close
    }
    emptyPriceChartingProductObject();
    setRowsToUpdateCondition([]);
  };

  //-------Handle table sort
  const onTableSort = (column, sortDirection) => {
    columnHeaders(
      columnHeaders.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };

  const handleRowSelectionChange = useCallback((state) => {
    setRowsToUpdateCondition(state.selectedRows);
  }, []);

  //-------Toggle Custom Item Modal
  const toggleCustomItemModal = () => {
    setIsCustomItemModal(!isCustomItemModal);
  };

  const handleAddCustomItem = () => {
    setEditCustomProduct(EMPTY_STRING);
    toggleCustomItemModal();
  };

  //-------UseEffect

  //-------update product condition and type
  useEffect(() => {
    if (
      priceChartingProductInfo &&
      isBatchInventoryModal &&
      !addInventoryItemModal
    ) {
      activateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
      setDefaultProductDataObject(
        markupPresets,
        () => {},
        currentStore,
        inventoryActions,
        productDataObject,
        addBatchInventory,
        () => {},
        tradeinMargin,
        true,
        setProductDataObject,
        setAddBatchInventory,
        priceChartingProductInfo,
        handleCalculateEachProductPercentage,
        scrollToTop,
        emptyPriceChartingProductObject,
        customTypes,
        shopifySettings
      );
      deactivateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
    }
    // eslint-disable-next-line
  }, [priceChartingProductInfo]);

  const handleResetBatch = () => {
    handleResetPrices(
      markupPresets,
      false,
      addBatchInventory,
      setAddBatchInventory,
      tradeinMargin,
      handleCalculateEachProductPercentage,
      currentStore
    );
  };

  //------ handle clear batch
  const handleClearBatch = () => {
    setAddBatchInventory([]);
  };
  const prevLength = useRef(addBatchInventory?.length);
  useEffect(() => {
    if (addBatchInventory?.length > prevLength.current) {
      getInStockProducts(
        currentStore,
        inventoryActions,
        addBatchInventory,
        setAddBatchInventory,
        markupPresets,
        handleCalculateEachProductPercentage,
        tradeinMargin,
        shopifySettings
      );
    }
    prevLength.current = addBatchInventory?.length;
    // eslint-disable-next-line
  }, [addBatchInventory?.length]);

  return (
    <>
      <Modal
        size="lg"
        centered
        animation={true}
        backdrop="static"
        onHide={handleCloseModal}
        dialogClassName="modal-90w"
        show={isBatchInventoryModal}
        className={`add-inventory-modal`}
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title>
            <span className="add-inventory-modal-header-name">
              Add Batch Inventory
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body py-0">
          {/* search inventory */}
          <Row className="m-0">
            <Col md={9} className="mb-0 ps-md-0">
              <SearchInventory
                modalType={inventoryConstants.INVENTORY_BATCH_MODAL}
                isBatch={true}
                isSearchCustomProduct={true}
                customTypes={customTypes}
                asyncSelectRef={asyncSelectRef}
                customCategories={customCategories}
              />
            </Col>
            <Col md={1}>
              <Button
                IconImage={AddIcon}
                isDisabled={false}
                handleClick={handleAddCustomItem}
                label={
                  isScreenLessThan1440(screenWidth)
                    ? buttonNameConstants.ADD_CUSTOM_ITEM
                    : `Add ${buttonNameConstants.ADD_CUSTOM_ITEM}`
                }
              />
            </Col>
            {rowsToUpdateCondition?.length && addBatchInventory?.length ? (
              <Col md={2} className="d-flex justify-content-end pe-md-0 gap-2">
                <Button
                  label={
                    isScreenLessThan1440(screenWidth)
                      ? EMPTY_STRING
                      : buttonNameConstants.DELETE
                  }
                  className={
                    isScreenLessThan1440(screenWidth)
                      ? " batch-delete-button"
                      : EMPTY_STRING
                  }
                  type="button"
                  buttonType={buttonTypeConstants.RED_BUTTON}
                  handleClick={() => {
                    handleBatchBulkDelete(
                      toggledClearRows,
                      addBatchInventory,
                      setToggleClearRows,
                      setAddBatchInventory,
                      rowsToUpdateCondition,
                      setRowsToUpdateCondition
                    );
                  }}
                  isDisabled={isAddInventoryInProgress(spinnerArray)}
                  IconImage={DeleteIcon}
                />
                <Button
                  label={buttonNameConstants.BULK_UPDATE}
                  type="button"
                  handleClick={() => {
                    handleBulkUpdateCondition(
                      isBulkModal,
                      setIsBulkModal,
                      rowsToUpdateCondition
                    );
                  }}
                  isDisabled={isAddInventoryInProgress(spinnerArray)}
                />
              </Col>
            ) : addBatchInventory?.length ? (
              <Col md={2} className="d-flex justify-content-end pe-md-0 gap-2">
                <Button
                  label={
                    isScreenLessThan1440(screenWidth)
                      ? EMPTY_STRING
                      : buttonNameConstants.CLEAR
                  }
                  className={
                    isScreenLessThan1440(screenWidth)
                      ? " batch-delete-button"
                      : EMPTY_STRING
                  }
                  IconImage={ResetCartIcon}
                  type="button"
                  buttonType={buttonTypeConstants.LIGHT_PURPLE}
                  handleClick={() => {
                    toggleConfirmationModal();
                  }}
                  isDisabled={isAddInventoryInProgress(spinnerArray)}
                />
                <Button
                  label={buttonNameConstants.SAVE}
                  type="button"
                  handleClick={() => {
                    handleAddBatchInventoryPark(
                      addBatchInventory,
                      currentStore,
                      addBatchInventoryDraft,
                      () => {
                        handleCloseModal(true);
                      },
                      addBatchInventoryRetrievedDraft
                    );
                  }}
                  isDisabled={isAddInventoryInProgress(spinnerArray)}
                />
              </Col>
            ) : (
              <></>
            )}
          </Row>
          {/* main body */}
          <Row className="mt-3">
            <EditableReactDataTableComponent
              tableId={TABLE_IDS.ADD_BATCH_INVENTORY}
              selectableRows
              columns={columnHeaders}
              onSort={onTableSort}
              gridState={gridState}
              data={[...addBatchInventory].reverse()}
              setGridState={setGridState}
              clearSelectedRows={toggledClearRows}
              total={addBatchInventory?.length}
              defaultSortFieldId={defaultSortFieldId}
              handleRowSelectionChange={handleRowSelectionChange}
            />
          </Row>
          {/*Modal footer */}
          <AddBatchInventoryFooter
            handleCogsValueChange={(data) => {
              handleTotalCogsValueChange(
                data,
                () => {},
                addBatchInventory,
                setAddBatchInventory
              );
            }}
            closeModal={handleCloseModal}
            spinnerArray={spinnerArray}
            handleResetBatch={handleResetBatch}
            handleSubmitAddBatchInventory={() =>
              handleSubmitAddBatchInventory(
                currentStore,
                activateSpinner,
                deactivateSpinner,
                handleCloseModal,
                handleClearFilter,
                addBatchInventory,
                addBatchInventorySubmit,
                transactionConstants.ADD_TRADE_BATCH_ITEM,
                activateImportInventorySpinner,
                addBatchInventoryRetrievedDraft
              )
            }
            currentStore={currentStore}
            addBatchInventory={addBatchInventory}
            data={totalBatchCalculation}
          />
        </Modal.Body>
      </Modal>
      {addInventoryItemModal && (
        <BatchProductEdit
          addToCart={(editProduct) => {
            addToCartInBatchTrade(
              editProduct,
              addBatchInventory,
              setEditTradeObject,
              setAddBatchInventory
            );
          }}
          editProductObject={editTradeObject}
          isBatchProductEditModal={addInventoryItemModal}
          toggleIsBatchProductEditModal={toggleAddInventoryItemModal}
        />
      )}
      <BatchBulkUpdateModal
        isBulkModal={isBulkModal}
        setIsBulkModal={setIsBulkModal}
        toggledClearRows={toggledClearRows}
        addBatchInventory={addBatchInventory}
        setToggleClearRows={setToggleClearRows}
        bulkUpdateCondition={bulkUpdateCondition}
        setAddBatchInventory={setAddBatchInventory}
        rowsToUpdateCondition={rowsToUpdateCondition}
        setBulkUpdateCondition={setBulkUpdateCondition}
        setRowsToUpdateCondition={setRowsToUpdateCondition}
      />
      <ConfirmationModal
        message={toastMessages.CLEAR_BATCH_WARNING}
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
      />
      {isCustomItemModal && (
        <AddCustomItem
          addToCart={(editProduct) => {
            addToCartInBatchTrade(
              editProduct,
              addBatchInventory,
              setEditTradeObject,
              setAddBatchInventory
            );
          }}
          invoiceBatchInventory={addBatchInventory}
          setInvoiceBatchInventory={setAddBatchInventory}
          editCustomProduct={editCustomProduct}
          isCustomItemModal={isCustomItemModal}
          toggleCustomItemModal={toggleCustomItemModal}
        />
      )}
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  inventory: state.inventory,
  tradeDiscount: state.tradeDiscount,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  productTags: state.inventory.productTags,
  allCategories: state.inventory.allCategories,
  shopifySettings: state.shopify.shopifySettings,
  tradeinMargin: state.tradeDiscount.tradeinMargin,
  markupPresets: state.tradeDiscount.markupPresets,
  addBatchInventory: state.inventory.addBatchInventory,
  isBatchInventoryModal: state.inventory.isBatchInventoryModal,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
  addBatchInventoryRetrievedDraft:
    state.inventory.addBatchInventoryRetrievedDraft,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  addBatchInventorySubmit: (
    data,
    handleCloseModal,
    handleClearFilter,
    addBatchInventoryRetrievedDraft
  ) =>
    dispatch(
      inventoryActions.addBatchInventory(
        data,
        handleCloseModal,
        handleClearFilter,
        undefined,
        addBatchInventoryRetrievedDraft
      )
    ),
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  getPricechartingProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getPricechartingProductById(productMetaData, productId)
    ),
  setPokemonProductInReducer: (productMetaData, value) =>
    dispatch(
      inventoryActions.setPokemonProductInReducer(productMetaData, value)
    ),
  setAddBatchInventory: (data) =>
    dispatch(success(data, inventoryConstants.SET_ADD_BATCH_INVENTORY)),
  handleDraftModal: (isToggle) =>
    dispatch({
      type: transactionConstants.SET_DRAFT_CONFIRMATION,
      data: isToggle,
    }),
  setIsBatchInventoryModal: (isModalOpen) =>
    dispatch({
      type: inventoryConstants.SET_IS_BATCH_INVENTORY + globalConstants.SUCCESS,
      data: isModalOpen,
    }),
  addBatchInventoryDraft: (data, successCallBack) =>
    dispatch(inventoryActions.addBatchInventoryDraft(data, successCallBack)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
  activateImportInventorySpinner: (data) =>
    dispatch(inventoryActions.activateImportInventorySpinner(data)),
  setAddBatchInventoryRetrievedDraft: (data) =>
    dispatch(
      custom(data, inventoryConstants.SET_ADD_BATCH_INVENTORY_RETRIEVED_DRAFT)
    ),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(AddBatchInventory);
